import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography } from '@mui/material';

import { useMountEffect, useSettings, Utils } from 'app/main/components';
import TotemDocumentsFolderItem from '../components/items/TotemDocumentsFolderItem';

export default function TotemDocumentsSection() {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [isLoading, setIsLoading] = React.useState(false);
	const [docsList, setDocsList] = React.useState<any[]>([]);

	useMountEffect(() => {
		setIsLoading(true);
		Utils.executeApi.get({
			url: 'api/hrm/documents',
			dispatch,
			successHandler: ({ data }) => {
				setDocsList(data.list || []);
				setIsLoading(false);
			}
		});
	});

	if (isLoading) return <></>;

	return (
		<div className="h-full p-24">
			<Typography className="mb-16 font-600" variant="h5">
				{t('TOTEM_HEADER_DOCUMENTS_TITLE')}
			</Typography>
			{docsList.length > 0 ? (
				<Grid container spacing={2}>
					{docsList?.map((docs, k) => (
						<Grid key={k} size={{ lg: 3, md: 4, sm: 6, xs: 12 }}>
							<TotemDocumentsFolderItem model={docs} />
						</Grid>
					))}
				</Grid>
			) : (
				<Grid container justifyContent="center">
					<Grid>
						<Typography variant="h6">{t('VIEW_LIST_NO_ITEMS').toUpperCase()}</Typography>
					</Grid>
				</Grid>
			)}
		</div>
	);
}
